import { getAuthenticatedInstance } from './helpers/axios.helpers';

const authenticatedInstance = getAuthenticatedInstance();

export async function getPlannings(): Promise<any> {
  return authenticatedInstance.get(
    '/plannings?select=*,sounds(id,title,path,description)'
  );
}
